export default "__VITE_ASSET__CFdg1RKC__"